import script from "./ShipProtocolTemplateView.vue?vue&type=script&lang=ts&setup=true"
export * from "./ShipProtocolTemplateView.vue?vue&type=script&lang=ts&setup=true"

import "./ShipProtocolTemplateView.vue?vue&type=style&index=0&id=071f1253&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-071f1253"]])

export default __exports__